import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientAccountModalService {

  private selectedCustomerIdSubject = new BehaviorSubject<string | null>(null);
  public selectedCustomerId$ = this.selectedCustomerIdSubject.asObservable();

  constructor() { }

  setSelectedCustomerId(customerId: string): void {
    this.selectedCustomerIdSubject.next(customerId);
  }

  getSelectedCustomerId(): string | null {
    return this.selectedCustomerIdSubject.value;
  }

  clearSelectedCustomerId(): void {
    this.selectedCustomerIdSubject.next(null);
  }
}
